import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  Breadcrumbs, LinearProgress, makeStyles, Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import UserForm from '../UserForm';
import { userActions } from '../../../redux/actions';
import PageLayout from '../../PageLayout';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: '#F8F8F8',
  },
  toolbar: {
    backgroundColor: '#F8F8F8',
    zIndex: 1,
  },
  toolbarTitle: {
    color: '#F79A56',
    flexGrow: 1,
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    backgroundColor: '#F8F8F8',
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(2),
    },
  },
}));

function EditUserPage(props) {
  const classes = useStyles();
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'user.edit.title', defaultMessage: 'Modificar usuario' });
  const usersText = intl.formatMessage({ id: 'user.usersTitle', defaultMessage: 'Usuarios' });
  const modifyText = intl.formatMessage({ id: 'app.modify', defaultMessage: 'Modificar' });
  const dispatch = useDispatch();
  const userId = props.match.params.id;
  const user = useSelector((state) => state.user.data);

  useEffect(() => {
    dispatch(userActions.get(userId));
  }, [dispatch, userId]);

  function EditUserBreadcrumbs() {
    const userLink = `/users/${userId}`;

    return (
      <Breadcrumbs className={classes.breadcrumbs} separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/users" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{usersText}</Typography>
        </Link>
        <Link color="inherit" to={userLink} style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{user.email}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{modifyText}</strong></Typography>
      </Breadcrumbs>
    );
  }

  function EditUserLoadingBreadcrumbs() {
    return (
      <Breadcrumbs className={classes.breadcrumbs} separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/users" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{usersText}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{modifyText}</strong></Typography>
      </Breadcrumbs>
    );
  }

  return (
    <>
      {user
        ? (
          <PageLayout title={title} breadCrumbs={<EditUserBreadcrumbs />}>
            <UserForm edit data={user} />
          </PageLayout>
        )
        : (
          <PageLayout title={title} breadCrumbs={<EditUserLoadingBreadcrumbs />}>
            <LinearProgress />
          </PageLayout>
        )}
    </>

  );
}

export default EditUserPage;
